<template>
  <div :class="contianerClass">
    <span :class="ns.e('value')">
      <slot />
    </span>
    <span v-if="flag" :class="ns.e('icon')">
      <el-icon v-if="flag === 'up'">
        <CaretTop />
      </el-icon>
      <el-icon v-else-if="flag === 'down'">
        <CaretBottom />
      </el-icon>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNamespace } from '@element-plus/hooks'
import { ElIcon } from '@element-plus/components/icon'
import { CaretBottom, CaretTop } from '@element-plus/icons-vue'
import { trendProps } from './trend'

defineOptions({
  name: 'ElTrend',
})

const ns = useNamespace('trend')
const props = defineProps(trendProps)

const contianerClass = computed(() => {
  const result = {
    [ns.b()]: true,
    [ns.m('color')]: props.color && !props.reverseColor,
    [ns.m('reverse-color')]: props.color && props.reverseColor,
    [ns.m('text-color')]:
      (props.color || props.reverseColor) && props.textColor,
    [ns.m(props.align)]: true,
  }
  if (props.flag) {
    result[ns.m(props.flag)] = true
  }
  return result
})
</script>
